import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFileArchive = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M12.5206 20.1674H16.4994C16.9856 20.1674 17.4519 19.9742 17.7957 19.6304C18.1395 19.2865 18.3326 18.8202 18.3326 18.3339V7.33304M18.3326 7.33304C18.3333 7.04254 18.2765 6.75477 18.1654 6.48634C18.0544 6.21791 17.8912 5.97414 17.6855 5.76909L14.3968 2.47982C14.1918 2.27404 13.9481 2.11089 13.6797 1.99981C13.4113 1.88872 13.1236 1.83189 12.8331 1.83261M18.3326 7.33304L13.7497 7.33304C13.5066 7.33304 13.2735 7.23645 13.1016 7.06453C12.9297 6.89261 12.8331 6.65943 12.8331 6.4163V1.83261M12.8331 1.83261H5.50055C5.01437 1.83261 4.5481 2.02578 4.20432 2.36962C3.86053 2.71346 3.6674 3.17982 3.6674 3.66609V14.2086M7.3337 11V10.0833M7.3337 16.5004V14.667M7.3337 16.5004C6.32128 16.5004 5.50055 17.3213 5.50055 18.3339C5.50055 19.3465 6.32128 20.1674 7.3337 20.1674C8.34612 20.1674 9.16685 19.3465 9.16685 18.3339C9.16685 17.3213 8.34612 16.5004 7.3337 16.5004ZM7.3337 6.4163V5.49956",
		stroke: "currentColor",
		strokeWidth: 1.3,
		strokeLinecap: "round"
	})]
});
const ForwardRef = forwardRef(SvgFileArchive);
export default ForwardRef;
